import styled from 'styled-components';

export const PostEditPageWrapper = styled.form`
  padding: 0 16px;
`;
